module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_responsive_guestbooks.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_responsive_guestbooks.png
// module id = iaE+
// module chunks = 0